// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1eGxS","validationTips":"StatementDescriptor_validationTips__27fvA"};